import { URLS } from '../../../consts/endpoints';
import { postData } from '../../../utils/http';
import { isString, isArray } from '../../../utils/isDefined';
import getErrorDetail from '../../../utils/getErrorDetail';

const moveRange = async ({ rangesIds, targetClientId, onProgress }) => {
  const results = [];

  for (const rangeId of rangesIds) {
    if (onProgress) {
      onProgress(rangeId, 'pending');
    }

    try {
      const response = await postData({
        url: `${URLS.EXTERNAL_NO_RANGES}/${rangeId}/move?new_client_id=${targetClientId}`,
        passErrors: true
      });
      results.push({ rangeId, success: true, response });

      if (onProgress) {
        onProgress(rangeId, 'success', response);
      }
    } catch (error) {
      const detail = getErrorDetail(error);

      results.push({ rangeId, success: false, error: detail });

      if (onProgress) {
        onProgress(rangeId, 'error', detail);
      }
    }
  }

  return results;
};

export default moveRange;
